import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
//import { eliminarInspector } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'
import {eliminarAtencionACliente} from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './CuadroAtencionAClienteComponent.module.css'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import CredencialComponent from './CredencialComponent'
import { DataGrid } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';

function CuadroInspectorComponent(props) {

    const dispatch = useDispatch()
    const { id, imagen, nombre, apellidos } = props.usuario

    const handleRemoveInspector = (id) => {
        dispatch(eliminarAtencionACliente(id))
    }

    const [initialStateFormik, setInitialStateFormik] = React.useState({

    })

    const solicitudes = useSelector(store => store.AtencionSolicitud.data)

    const solicitudesStatus = useSelector(store => store.AtencionSolicitud.status)

    React.useEffect(() => {
        if (solicitudesStatus === 0) {
            dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
        }
    }, [dispatch, solicitudes.status])

    const columns = [

        /*{ field: 'id', headerName: 'ID', with: 30 },*/
        { field: 'Folio',headerAlign: 'center', headerName: 'Folio', width: 150 },
        { field: 'FechaDecreación',headerAlign: 'center', headerName: 'Fecha de creación', width: 200 },
        /*{ field: 'FechaUltimaDeModificacion', headerName: 'Fecha ultima de modificacion', width: 250 },*/
        { field: 'Nombre',headerAlign: 'center', headerName: 'Nombre', width: 250 },
        // { field: 'idlogin',headerAlign: 'center', headerName: 'Num Asociado', width: 130},
        // {
        //     field: 'accion',headerAlign: 'center', headerName: 'Accion', width: 150,
        //     renderCell: (params) =>
        //     <button 
        //     // onClick={() => verDetalle(params)} 
        //     className='btn btnNaranja btn-sm'>Asignar</button>
        // }
    ]

    const rows = [];
    {
        solicitudes.fc_01_solicitudderegistro.map(solicitud => {
            rows.push({ id: uuidv4(), Folio: solicitud.idfc01_solicitudregistro, FechaDecreación: solicitud.fechasolicitud, Nombre: 'fc_01_solicitudderegistro', idlogin: solicitud.idlogin, uri: 'FC_01/obtenerUnaSolicitudFC_01/', uriAnexos:'FC_01/obtenerAnexosDeSolicitudDeRegistro/' })
        })
    }

    const rowsAsociado = [
        {id:  uuidv4(), NumeroDeSocio: '0001', Nombre: 'Yugen S.A. de C.V.'},
        {id:  uuidv4(), NumeroDeSocio: '0003', Nombre: 'Jorge Hernández López'},
        {id:  uuidv4(), NumeroDeSocio: '0002', Nombre: 'Whirlpool S.A. de C.V.'},
        {id:  uuidv4(), NumeroDeSocio: '0004', Nombre: 'Maria Toledo Reyes'},
    ];
    
    const columnsAsociado = [
        { field: 'NumeroDeSocio', headerAlign: 'center', headerName: 'Numero De Socio', width: 300 },
        { field: 'Nombre', headerAlign: 'center', headerName: 'Nombre/Razón social', width: 450 },
        // {
        //     field: 'accion',headerAlign: 'center', headerName: 'Accion', width: 250,
        //     renderCell: (params) =>
        //     <button 
        //     // onClick={() => verDetalle(params)} 
        //     className='btn btnNaranja btn-sm'>Asignar</button>
        // }
    ]

    const data = [
        {
            name: 'Enero',
            pv: 2400,
            amt: 2400,
        },
        {
            name: 'Marzo',
            pv: 1398,
            amt: 2210,
        },
        {
            name: 'Abril',
            pv: 9800,
            amt: 2290,
        },
        {
            name: 'Mayo',
            pv: 3908,
            amt: 2000,
        },
        {
            name: 'Junio',
            pv: 4800,
            amt: 2181,
        },
        {
            name: 'Julio',
            pv: 3800,
            amt: 2500,
        },
        {
            name: 'Agosto',
            pv: 4300,
            amt: 2100,
        },
    ];

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1300,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };


    const [openReasignarVisita, setOpenReasignarVisita] = React.useState(false);
    const handleOpenReasignarVisita = () => setOpenReasignarVisita(true);
    const handleCloseReasignarVisita = () => setOpenReasignarVisita(false);

    const [openEstadisticas, setOpenEstadisticas] = React.useState(false);
    const handleOpenEstadisticas = () => setOpenEstadisticas(true);
    const handleCloseEstadisticas = () => setOpenEstadisticas(false);

    const [openCredencial, setOpenCredencial] = React.useState(false);
    const handleOpenCredencial = () => setOpenCredencial(true);
    const handleCloseCredencial = () => setOpenCredencial(false);

    let idsParaAsignar = []
    const handleAssign = () => {
        // console.log(idsParaAsignar)
    }
    
    return (
        <Fragment>
            <div className={`col-md-4 text-center`} >
                <div className={`${estilos.cuadro}`}>
                    <img className={`img-fluid ${estilos.imagenInspector}`} src={imagen} onClick={handleOpenCredencial}></img>
                    <br /><br />
                    <div>
                        <div className={`${estilos.nombreInspector} text-center`}>
                            <h3>{nombre} {apellidos}</h3>
                        </div>
                        <hr></hr>
                        {/* <div className={`${estilos.nombreInspector} text-center`}>
                            <h5>EX - 01 GUERRERO-CDMX-PUE </h5>
                        </div>

                        <div>

                        </div>


                        <hr></hr> */}
                        <table className={`${estilos.textoInformativo}`}>
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td>Solicitudes de registro asignadas:</td>
                                    <td>15</td>
                                </tr>
                                <tr>
                                    <td>Clientes asociados asignados:</td>
                                    <td>40</td>
                                </tr>
                                <tr>
                                    <td>Solicitudes revisadas:</td>
                                    <td>234</td>
                                </tr>
                                <tr>
                                    <td>Promedio de solicitudes/semana:</td>
                                    <td>10</td>
                                </tr>
                                {/* <tr>
                                    <td>Nivel de atención:</td>
                                    <td><button className='badge btn-success'>Alto</button></td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <hr></hr>
                    <h5>Opciones:</h5>
                    <div className={`${estilos.botonera} text-center`}>
                        <button onClick={() => props.onModify(props.usuario)} className='badge btn-warning col-4'>Modificar </button>
                        <button onClick={() => handleRemoveInspector(id)} className='badge btn-danger col-4'>Eliminar </button>
                    </div><br />

                    <div className={`${estilos.botonera} text-center`}>
                        {/* <button onClick={handleOpenReasignarVisita} className='badge btn-primary'>Reasignar Zona </button> */}
                        <button onClick={handleOpenReasignarVisita} className='badge btn-primary'>Asignar FC_01 </button>
                        {/* <button onClick={handleOpenEstadisticas} className='badge btn-success'>Ver estadísticas</button> */}
                        <button onClick={handleOpenEstadisticas} className='badge btn-success'>Asignar asociado</button>
                    </div>
                    <br /><br />
                </div>
            </div>

            <Modal
                open={openReasignarVisita}
                onClose={handleCloseReasignarVisita}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2" align='center'>
                        Asiganación de solicitudes de registro
                    </Typography>
                    <div className='row justify-content-center'>
                        <div className='col-8 bg-white'>
                            <div style={{ height: 600, width: '100%' }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={10}
                                    getRowId={(row) => row.id}
                                    rowsPerPageOptions={[10]}
                                    checkboxSelection={true} 
                                    onSelectionModelChange={(ids) => {
                                        idsParaAsignar = ids
                                    }}
                                    // hideFooterPagination 
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        <div className='text-end'>
                            <button type='button' className='btn btnNaranja btn-sm' onClick={() => handleAssign()}>Asignar</button>
                        </div>
                    </div>
                    
                    
                </Box>
            </Modal>


            <Modal
                open={openEstadisticas}
                onClose={handleCloseEstadisticas}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2" align='center'>
                        Asignación de clientes asociados
                    </Typography>
                    <br /><br />
                    <div className='row justify-content-center'>
                        <div className='col-8 bg-white'>
                            <div style={{ height: 500, width: '150%' }}>
                                <DataGrid
                                    rows={rowsAsociado}
                                    columns={columnsAsociado}
                                    pageSize={10}
                                    rowsPerPageOptions={[7]}
                                    checkboxSelection={true}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        <div className='text-end'>
                            <button type='button' className='btn btnNaranja btn-sm'>Asignar</button>
                        </div>
                    </div>
                    {/* <LineChart width={1100} height={300} data={data}>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line type="monotone" dataKey="uv" stroke="#8884d8" />
                        <Line type="monotone" dataKey="pv" stroke="#82ca9d" />
                    </LineChart> */}

                </Box>
            </Modal>

            <Modal
                open={openCredencial}
                onClose={handleCloseCredencial}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>                
                    <CredencialComponent inspector={props.usuario}></CredencialComponent>
                </Box>
            </Modal>
        </Fragment>
    );
};


export default withRouter(CuadroInspectorComponent)
